// extracted by mini-css-extract-plugin
export default {"user-avatar":"_121Hz","userAvatar":"_121Hz","pixelated":"_1eq6W"};